const differentiators = [
  {
    icon: 'ri-heart-pulse-line',
    title: 'Atención Cálida',
    desc: 'Te tratamos como parte de nuestra familia. Cada visita es una experiencia cómoda, sin miedo y con plena confianza.',
    stat: '100%',
    statLabel: 'satisfacción',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Especialistas Certificados',
    desc: 'Nuestros profesionales cuentan con formación especializada y actualización continua en las últimas técnicas dentales.',
    stat: '5★',
    statLabel: 'calificación',
  },
  {
    icon: 'ri-eye-line',
    title: 'Resultados Visibles',
    desc: 'Transformaciones reales y duraderas. Desde el primer tratamiento notarás la diferencia en tu sonrisa y autoestima.',
    stat: '15+',
    statLabel: 'opiniones',
  },
  {
    icon: 'ri-building-2-line',
    title: 'Instalaciones Modernas',
    desc: 'Clínica equipada con tecnología de vanguardia en un ambiente limpio, confortable y totalmente profesional.',
    stat: '1er',
    statLabel: 'nivel CDMX',
  },
];

export default function ExperienceSection() {
  return (
    <section id="experience" className="py-28 bg-[#0A2540] relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#3A86FF]/10 rounded-full blur-[120px]" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#3A86FF]/8 rounded-full blur-[100px]" />
      <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
        backgroundSize: '40px 40px'
      }} />

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16 scroll-animate">
          <span className="inline-block text-[#3A86FF] font-semibold text-sm tracking-widest uppercase mb-3">
            ¿Por qué elegirnos?
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-5">
            Nuestra{' '}
            <span className="bg-gradient-to-r from-[#3A86FF] to-[#6aa3ff] bg-clip-text text-transparent">
              Diferencia
            </span>
          </h2>
          <p className="text-white/60 text-lg max-w-xl mx-auto font-light">
            En MF Dental combinamos tecnología, experiencia y calidez humana para ofrecerte la mejor atención dental en CDMX.
          </p>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {differentiators.map((item, i) => (
            <div
              key={item.title}
              className={`group glass-dark rounded-3xl p-7 scroll-animate anim-delay-${i * 100} hover:-translate-y-2 transition-all duration-300 cursor-default`}
            >
              {/* Stat */}
              <div className="flex items-start justify-between mb-6">
                <div className="w-14 h-14 flex items-center justify-center bg-[#3A86FF]/20 rounded-2xl group-hover:bg-[#3A86FF]/35 transition-colors duration-300">
                  <i className={`${item.icon} text-[#3A86FF] text-2xl`} />
                </div>
                <div className="text-right">
                  <div className="text-[#3A86FF] font-extrabold text-2xl">{item.stat}</div>
                  <div className="text-white/40 text-xs">{item.statLabel}</div>
                </div>
              </div>

              <h3 className="text-white font-bold text-lg mb-3">{item.title}</h3>
              <p className="text-white/55 text-sm leading-relaxed">{item.desc}</p>

              {/* Bottom accent line */}
              <div className="mt-6 h-0.5 w-0 bg-gradient-to-r from-[#3A86FF] to-transparent group-hover:w-full transition-all duration-500 rounded-full" />
            </div>
          ))}
        </div>

        {/* Bottom CTA strip */}
        <div className="mt-16 scroll-animate">
          <div className="glass rounded-3xl px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-[#3A86FF]/25 rounded-full">
                <i className="ri-map-pin-2-line text-[#3A86FF] text-xl" />
              </div>
              <div>
                <p className="text-white font-semibold">Av. 504 #51, San Juan de Aragón</p>
                <p className="text-white/55 text-sm">Gustavo A. Madero, CDMX · Abierto hasta las 8 p.m.</p>
              </div>
            </div>
            <div className="flex items-center gap-4 flex-shrink-0">
              <a
                href="tel:5534748982"
                className="flex items-center gap-2 border border-white/25 hover:border-[#3A86FF] text-white hover:text-[#3A86FF] px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line" />
                </div>
                55 3474 8982
              </a>
              <a
                href="https://maps.google.com?q=Av.+504+51,+Pueblo+San+Juan+de+Aragón,+Gustavo+A.+Madero,+CDMX"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 bg-[#3A86FF] hover:bg-[#1a6aff] text-white px-5 py-2.5 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-navigation-line" />
                </div>
                Cómo llegar
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
